const SIGNIN_ERROR_MESSAGES = {
    emptyEmail: 'メールアドレスを入力してください。',
    invalidEmail: 'メールアドレスの形式が正しくありません。',
    emptyPassword: 'パスワードを入力してください。',
    doesNotExistAccount: 'アカウントが存在しません。再度入力内容を確認ください',
};
export default SIGNIN_ERROR_MESSAGES;
